/**
 * Google Analytics Service
 * Helper functions for tracking events with Google Analytics
 */

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 * @param {Object} eventParams - Event parameters (category, label, value, etc.)
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Track a button click
 * @param {string} buttonId - Identifier for the button
 * @param {string} buttonLabel - Human-readable label (optional)
 * @param {Object} additionalParams - Additional parameters (optional)
 */
export function trackButtonClick(buttonId, buttonLabel = null, additionalParams = {}) {
  trackEvent('button_click', {
    event_category: 'button',
    event_label: buttonLabel || buttonId,
    button_id: buttonId,
    ...additionalParams,
  });
}

/**
 * Track a tab click/switch
 * @param {string} tabId - Identifier for the tab
 * @param {string} tabLabel - Human-readable label (optional)
 * @param {Object} additionalParams - Additional parameters (optional)
 */
export function trackTabClick(tabId, tabLabel = null, additionalParams = {}) {
  trackEvent('tab_click', {
    event_category: 'tab',
    event_label: tabLabel || tabId,
    tab_id: tabId,
    ...additionalParams,
  });
}

/**
 * Track a custom action
 * @param {string} actionName - Name of the action
 * @param {Object} params - Additional parameters
 */
export function trackAction(actionName, params = {}) {
  trackEvent('custom_action', {
    event_category: 'action',
    event_label: actionName,
    action_name: actionName,
    ...params,
  });
}

export default {
  trackEvent,
  trackButtonClick,
  trackTabClick,
  trackAction,
};
